<template>
  <div class="empty-state">
    <div class="empty-state__icon-wrapper">
      <v-icon :icon="icon" size="40" color="blue-gray" />
    </div>
    <p class="empty-state__message">{{ displayMessage }}</p>
    <v-btn v-if="actionLabel" variant="outlined" color="primary" class="mt-4" @click="$emit('action')">
      {{ actionLabel }}
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: (v) => ["no-data", "no-results", "error"].includes(v),
  },
  message: {
    type: String,
    default: "",
  },
  actionLabel: {
    type: String,
    default: "",
  },
});

defineEmits(["action"]);

const defaultMessages = {
  "no-data": "No items yet",
  "no-results": "No items match your filters",
  error: "Failed to load data",
};

const icons = {
  "no-data": "mdi-tray-remove",
  "no-results": "mdi-filter-off-outline",
  error: "mdi-alert-circle-outline",
};

const displayMessage = computed(() => props.message || defaultMessages[props.variant]);
const icon = computed(() => icons[props.variant]);
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  animation: fadeIn 300ms ease forwards;
}

.empty-state__icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, $lh_dash_bg, rgba($lh_color_blue_gray, 0.08));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-state__message {
  font-size: $lh_body1_size;
  color: $lh_color_blue_gray;
  text-align: center;
}
</style>
